import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuándo recibo el ebook?',
    a: 'Acceso inmediato después de la compra. Recibirás un correo con todos los enlaces para descargar el material y los bonos al instante.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No, el programa está diseñado desde cero absoluto. Es ideal para personas sedentarias que nunca corrieron o que intentaron y abandonaron.'
  }, {
    q: '¿Funciona si siempre abandono?',
    a: 'Sí, está diseñado específicamente para eso. El enfoque principal del programa es construir el hábito y la disciplina mediante un sistema, no dependiendo de la motivación.'
  }, {
    q: '¿Puedo usarlo desde el celular?',
    a: 'Sí, funciona en cualquier dispositivo. Podés descargar los archivos PDF en tu celular, tablet o computadora y llevarlos con vos a donde vayas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-light py-20 md:py-32" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="text-center mb-12" data-id="element-50">
            <h2 className="text-3xl md:text-4xl font-black text-dark mb-4" data-id="element-51">
              Preguntas Frecuentes
            </h2>
            <p className="text-xl text-gray-600" data-id="element-52">
              Todo lo que necesitás saber antes de empezar.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-54">
                <div className={`bg-white rounded-2xl border transition-all duration-300 overflow-hidden ${isOpen ? 'border-primary shadow-md' : 'border-gray-200 shadow-sm hover:border-primary/50'}`} data-id="element-55">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-56">
                    <span className="font-bold text-lg text-dark pr-8" data-id="element-57">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-6 h-6 text-primary flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-58" />
                  </button>

                  <div className={`px-6 transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-59">
                    <p className="text-gray-600 leading-relaxed" data-id="element-60">{faq.a}</p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}